import { Card, Typography, Tabs } from "antd"
import { useState } from "react";
import { useAuth } from "../../../../store/AuthContext/AuthContext";
import { useTranslation } from "react-i18next";
import { SettingOutlined, ShopOutlined } from "@ant-design/icons";
import SelectPeriod from "../../../components/model/selectMonths/SelectPeriod";
import { Benchmark } from "./cities/Benchmark";
import { Leads } from "./leads/Leads";
import { LocalSEO } from "./business/LocalSEO";
import { useIsAuthorized } from "../../common/roles/Roles";
import { ModuleAccessGate } from "../../common/roles/ModuleAccessGate";
import { PageTitle } from "../../common/PageTitle";
import { PageFilters, PageFilterField } from "../../common/PageFilters";

const { Paragraph } = Typography;

const COMPETITORS_PAGE_INFO = 'Mide la visibilidad local de tus establecimientos y descubre los competidores mejor posicionados en las keywords más relevantes para ti. Si además gestionas múltiples establecimientos, podrás hacerlo de una manera más eficiente gracias a la programación masiva de nuestro ranking tracker y una presentación de los datos que permite tener la visión global de las métricas.';

export const Competitors = () => (
	<ModuleAccessGate module='COMPETITORS' title='SEO Local' pageInfo={COMPETITORS_PAGE_INFO}>
		<CompetitorsContent />
	</ModuleAccessGate>
);

const CompetitorsContent = () => {

	const [selectedType, setSelectedType] = useState('LAST_3MONTHS');	    		
	const isAuthorized = useIsAuthorized();
    const { t } = useTranslation();	
        
    return (
		<>
        <Card className='main-card-content'>            
            
			<PageTitle
				title='SEO Local'
				pageInfo={COMPETITORS_PAGE_INFO}
				extra={
					<PageFilters>
						<PageFilterField label='Periodo'>
							<SelectPeriod setSelectedType={setSelectedType} defaultValue='LAST_3MONTHS'/>
						</PageFilterField>
					</PageFilters>
				}
			/>
			<br/>

			<Tabs defaultActiveKey="1" type="line">    

	            <Tabs.TabPane
                    tab={<span className='title-tabPane'>Mis Locales</span>}
                    key="1">
					<LocalSEO selectedType={selectedType}/>                    						
                </Tabs.TabPane>            

				{isAuthorized(['ROLE_CLIENT', 'ROLE_GUEST_VIEW', 'ROLE_ADMIN']) &&
					<Tabs.TabPane
						tab={<span className='title-tabPane'>Ciudades</span>}
						key="2">
						<Benchmark selectedType={selectedType}/>
					</Tabs.TabPane> 
				}

				{isAuthorized(['ROLE_AGENT', 'ROLE_ADMIN']) &&
					<Tabs.TabPane
						tab={<span className='title-tabPane'>Mis Leads</span>}
						key="3">	
						<Leads selectedType={selectedType}/>   					
					</Tabs.TabPane> 
				}

			</Tabs>
        </Card>						
		</>
    )
}
